import { render, staticRenderFns } from "./ReportSimpleDataTable.vue?vue&type=template&id=e93b1c32&scoped=true"
import script from "./ReportSimpleDataTable.vue?vue&type=script&lang=js"
export * from "./ReportSimpleDataTable.vue?vue&type=script&lang=js"
import style0 from "./ReportSimpleDataTable.vue?vue&type=style&index=0&id=e93b1c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93b1c32",
  null
  
)

export default component.exports